import React from 'react'
import UserList from '../../components/admin/users/UserList'

function UserListPage() {
  return (
    <UserList/>
  )
}

export default UserListPage